import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getEventStatus = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `event-status`);
};
export const AddEventStatus = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-status/create`,
    obj,
    { headers }
  );
};

export const EditEventStatus = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-status/update`,
    obj,
    { headers }
  );
};

export const DeleteEventStatus = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-status/delete`,
    obj,
    { headers }
  );
};
